import { MonitorPlay, Radio } from "lucide-react";
import { usePresentation } from "@/context/PresentationContext";

export function PresentationToggle() {
  const { isDemo, toggle } = usePresentation();
  return (
    <button
      onClick={toggle}
      data-testid="presentation-toggle"
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold ring-1 transition-colors ${
        isDemo
          ? "bg-[#B28A3D]/15 text-[#7a5d27] ring-[#B28A3D]/40 hover:bg-[#B28A3D]/25"
          : "bg-emerald-50 text-emerald-700 ring-emerald-200 hover:bg-emerald-100"
      }`}
      title={isDemo ? "Currently showing sample data — click for live" : "Currently showing live data — click for a presentation demo"}
    >
      {isDemo ? <MonitorPlay className="h-3.5 w-3.5" /> : <Radio className="h-3.5 w-3.5" />}
      {isDemo ? "Presentation Mode" : "Live Data"}
    </button>
  );
}
